import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import EmailLogsCard from "./components/EmailLogsIndex.jsx";

const EmailLogs = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Email logs</h3>
          <h3 className="page-subhead subhead">
            <Link to="/">Home</Link> / Email logs
          </h3>
        </Col>
      </Row>
      <Row>
        <EmailLogsCard />
      </Row>
    </Container>
  );
};

export default EmailLogs;
